import React, { useEffect, useMemo, useState } from "react";
import { Dropdown, DropdownItem, DropdownMenu, DropdownToggle } from "reactstrap";

import flagBr from "../../assets/images/flags/br.svg";
import flagUs from "../../assets/images/flags/us.svg";
import flagSpain from "../../assets/images/flags/spain.svg";
import i18n from "../../i18n";
import {
  I18N_STORAGE_KEY,
  resolveHostDefaultLocale,
} from "../../helpers/hostDefaultLocale";

const STORAGE_KEY = I18N_STORAGE_KEY;
const DEFAULT_LOCALE = resolveHostDefaultLocale(
  typeof window !== "undefined" ? window.location.hostname : "localhost",
  typeof navigator !== "undefined" ? navigator.language : null
);

interface LanguageOption {
  code: string;
  label: string;
  flag: string;
}

const LANGUAGES: LanguageOption[] = [
  { code: "pt-BR", label: "Português (Brasil)", flag: flagBr },
  { code: "en", label: "English", flag: flagUs },
  { code: "es", label: "Español", flag: flagSpain },
];

const LanguageDropdown = () => {
  const [selectedLang, setSelectedLang] = useState(
    () => localStorage.getItem(STORAGE_KEY) || i18n.language || DEFAULT_LOCALE
  );
  const [isLanguageDropdown, setIsLanguageDropdown] = useState(false);

  useEffect(() => {
    const syncLanguage = (lang: string) => {
      setSelectedLang(lang);
    };

    syncLanguage(i18n.language || DEFAULT_LOCALE);
    i18n.on("languageChanged", syncLanguage);

    return () => {
      i18n.off("languageChanged", syncLanguage);
    };
  }, []);

  const selectedLanguage = useMemo(
    () => LANGUAGES.find((language) => language.code === selectedLang) ?? LANGUAGES[0],
    [selectedLang]
  );

  const changeLanguageAction = async (lang: string) => {
    await i18n.changeLanguage(lang);
    localStorage.setItem(STORAGE_KEY, lang);
    setSelectedLang(lang);
  };

  const toggleLanguageDropdown = () => {
    setIsLanguageDropdown((open) => !open);
  };

  return (
    <Dropdown
      isOpen={isLanguageDropdown}
      toggle={toggleLanguageDropdown}
      className="ms-1 topbar-head-dropdown header-item"
    >
      <DropdownToggle
        className="btn btn-icon btn-topbar btn-ghost-secondary rounded-circle"
        tag="button"
      >
        <img
          src={selectedLanguage.flag}
          alt="Header Language"
          height="20"
          className="rounded"
        />
      </DropdownToggle>
      <DropdownMenu className="notify-item language py-2">
        {LANGUAGES.map((language) => (
          <DropdownItem
            key={language.code}
            onClick={() => changeLanguageAction(language.code)}
            className={`notify-item ${selectedLang === language.code ? "active" : ""}`}
          >
            <img
              src={language.flag}
              alt={language.label}
              className="me-2 rounded"
              height="18"
            />
            <span className="align-middle">{language.label}</span>
          </DropdownItem>
        ))}
      </DropdownMenu>
    </Dropdown>
  );
};

export default LanguageDropdown;
